"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectorUbicacionExacta = void 0;

var _react = _interopRequireDefault(require("react"));

var _googleMapReact = _interopRequireDefault(require("google-map-react"));

var _material = require("@mui/material");

var _lodash = _interopRequireDefault(require("lodash"));

var _style = _interopRequireDefault(require("./style"));

var _markerAa_c_ = _interopRequireDefault(require("../../images/marker-aa_c_30.png"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class SelectorUbicacionExacta extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onChangeMostrarUbicacion = this.onChangeMostrarUbicacion.bind(this);
    this.onChangeMap = this.onChangeMap.bind(this);
    this.state = {
      markerSize: 150,
      zoom: this.props.zoom
    };
  }

  onChangeMap({
    center,
    zoom
  }) {
    this.setState({
      zoom,
      markerSize: _lodash.default.max([50, (150 + _lodash.default.min([0, zoom - 15]) * 20) * _lodash.default.max([1, zoom - 14])])
    });
    const {
      lat,
      lng
    } = this.props;

    if (!(lng == center.lng) && !(lat == center.lat)) {
      this.props.onChange({
        lat: center.lat.toString(),
        lng: center.lng.toString()
      });
    }
  }

  onChangeMostrarUbicacion(event) {
    const value = event.target.value === 'marker' ? 1 : 0;
    this.props.onChange({
      mostrar_ubicacion_exacta: value
    });
  }

  render() {
    const MARKER_SIZE = this.state.markerSize;
    const circuloCentrado = {
      width: MARKER_SIZE,
      height: MARKER_SIZE,
      marginLeft: -MARKER_SIZE / 2,
      marginTop: -MARKER_SIZE / 2
    };
    const {
      lat,
      lng,
      mostrar_ubicacion_exacta,
      googleApiKey,
      es_siro
    } = this.props;
    return (0, _react2.jsx)("div", {
      css: _style.default.root
    }, !es_siro ? (0, _react2.jsx)(_material.FormControl, {
      component: "fieldset",
      required: true,
      css: _style.default.formControl
    }, (0, _react2.jsx)(_material.RadioGroup, {
      "aria-label": "gender",
      name: "gender1",
      css: _style.default.group,
      value: mostrar_ubicacion_exacta == 1 ? 'marker' : 'circle',
      onChange: this.onChangeMostrarUbicacion
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      value: "marker",
      control: (0, _react2.jsx)(_material.Radio, null),
      label: "Mostrar Ubicaci\xF3n Exacta"
    }), (0, _react2.jsx)(_material.FormControlLabel, {
      value: "circle",
      control: (0, _react2.jsx)(_material.Radio, null),
      label: "Ocultar Ubicaci\xF3n Exacta"
    }))) : null, (0, _react2.jsx)(_material.Typography, {
      variant: "body1",
      css: _style.default.bodyText
    }, "\xBFEst\xE1 el marcador en el lugar correcto?"), (0, _react2.jsx)(_material.Typography, {
      variant: "body1",
      css: _style.default.bodyText
    }, "Si no es as\xED, mov\xE9 el mapa hasta posicionar el puntero en el lugar adecuado."), (0, _react2.jsx)("div", {
      css: _style.default.containerMap
    }, mostrar_ubicacion_exacta == 1 ? (0, _react2.jsx)("div", {
      css: _style.default.centerMarker
    }, (0, _react2.jsx)("img", {
      alt: "",
      src: _markerAa_c_.default
    })) : (0, _react2.jsx)("div", null, (0, _react2.jsx)("div", {
      css: _style.default.centerMarker
    }, (0, _react2.jsx)("img", {
      alt: "",
      src: _markerAa_c_.default
    })), (0, _react2.jsx)("div", {
      css: _style.default.areaMarker,
      style: circuloCentrado
    }, (0, _react2.jsx)("div", {
      css: _style.default.contenedorCirculo,
      style: {
        width: this.state.markerSize,
        height: this.state.markerSize,
        borderRadius: '50%'
      }
    }, (0, _react2.jsx)("div", {
      css: _style.default.circulo,
      style: {
        width: this.state.markerSize,
        height: this.state.markerSize,
        borderRadius: '50%'
      }
    })))), lat && lng ? (0, _react2.jsx)(_googleMapReact.default, {
      bootstrapURLKeys: {
        key: googleApiKey
      },
      center: {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      },
      zoom: this.state.zoom,
      onChange: this.onChangeMap,
      options: {
        fullscreenControl: false
      }
    }) : null));
  }

}

exports.SelectorUbicacionExacta = SelectorUbicacionExacta;
var _default = SelectorUbicacionExacta;
exports.default = _default;